export const AppSettings = Object.freeze({
    "SERVER_URL": 'https://mobile-api.atarix.co.il/mentorApi/api/',
    "APP_VERSION": 'https://mobile-api.atarix.co.il/mentorApi/app_version.php',
    "RAMATGANEMONAL_DOMAIN": 'https://www.mbe-rg.co.il/',
    "RAMATGANEMONAL_URL": 'https://www.mbe-rg.co.il/mentorApi/api/',
    "SECURITY_KEY": '',
    "FACEBOOKID": '',
    "TOAST": {
        "duration": 3000,
        "position": "bottom"
    },
    /** Firebase web app config (also used by firebase-messaging-sw.js). */
    "FIREBASE": {
        apiKey: "AIzaSyDFZaUmaTsBEujG8Bpp4dpQ9AtLcStMvBo",
        authDomain: "mentorapp-cf6a9.firebaseapp.com",
        databaseURL: "https://mentorapp-cf6a9-default-rtdb.firebaseio.com",
        projectId: "mentorapp-cf6a9",
        storageBucket: "mentorapp-cf6a9.firebasestorage.app",
        messagingSenderId: "87313463135",
        appId: "1:87313463135:web:c4481fefd5d698662ca8ea",
        measurementId: "G-4PQT1XXJBL",
    },
    /**
     * Web Push VAPID public key from Firebase Console:
     * Project Settings → Cloud Messaging → Web Push certificates → Key pair.
     * Required for FCM token on browsers (leave empty to skip web push init).
     */
    "FIREBASE_WEB_PUSH_VAPID_KEY": "BPIZiTc-YsoBu9Bi802xa7siZfcr3Y37QnNbCwAgVhnzTiXB_ME5760nO4oY4EVLjods3V_4glZ4J2IDHETIlmY",
    "PUSH_LOCAL_STORAGE_KEY": "push",
    /** Last FCM token emailed via mailer; skip token mail when unchanged. */
    "WEB_PUSH_LAST_MAILED_TOKEN_KEY": "mentorWebPushLastMailedToken",
    /** localStorage prefix — welcome push shown once per user on this device. */
    "WEB_PUSH_WELCOME_SHOWN_KEY": "mentorWebPushWelcomeShown",
    /** Web push → mailer.php (POST: name, email, subject, message, phone; user details in message). */
    "WEB_PUSH_MAILER_URL": "",
    "WEB_PUSH_MAILER_EMAIL": "",
    "WEB_PUSH_MAILER_PHONE": "",
    "WEB_PUSH_NAME": "mentor",
    "WEB_PUSH_DOMAIN": "mentor.atarix.co.il",
    "WEB_APP_URL": "https://mentor.atarix.co.il/",
    /** Optional override; default welcome/icon uses assets/imgs/logo_no_bg.png. */
    "WEB_PUSH_NOTIFICATION_ICON": "",
    "RECAPTCHA_SITE_KEY": "6LdPvTotAAAAAFvTclv6hrioyp2tOSLEOq-CCxdl",
});



// WEBPACK FOOTER //
// ./src/services/app-settings.ts